import { Component, ChangeDetectorRef, ChangeDetectionStrategy, ViewRef, Output, EventEmitter, Input, HostListener } from '@angular/core';
import { Column } from '../../models/column';
import { EventData } from '../../models/eventdata';
import { ValueField } from '../../models/valuefield';
import { HelperService } from '../../Services/Helper.Service';
import { FieldStyle } from '../../models/fieldstyle';

@Component({
  selector: 'mdg-format',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // templateUrl: 'MDG.Format.html',
  template: `<div *ngIf="showFormat" class='mdg-options-container'>
  <div class="mdg-options-popup-container formula-popup">
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <div class='row'>
          <div class="col-md-12 col-sm-12 col-xs-12">
            <h3>Format Fields</h3>
          </div>
        </div>
        <hr class="buffer-5-0">
      </div>
      <div class="col-md-3 col-sm-4 col-xs-12 content">
        <div class='border-top-ddd border-left-ddd border-right-ddd'>
          <div class="padding-5 bg-f7f7f7">List of Field(s)
          </div>
        </div>
        <div class="mdg-options-stack-container overflow-y border-ddd">
          <div class="border-bottom-ddd padding-5 cursor-pointer" *ngFor="let col of selectedRows" (click)='selectColumn(col)' title="{{col.displayName}}">
            <i class='fa fa-reorder cursor-move font-10'></i> {{col.displayName}}
          </div>
          <div class="border-bottom-ddd padding-5 cursor-pointer" *ngFor="let col of selectedColumns" (click)='selectColumn(col)' title="{{col.displayName}}">
            <i class='fa fa-reorder cursor-move font-10'></i> {{col.displayName}}
          </div>
          <div class="border-bottom-ddd padding-5 cursor-pointer" *ngFor="let col of selectedValues" (click)='selectColumn(col.column)' title="{{col.column.displayName}}">
            <i class='fa fa-reorder cursor-move font-10'></i> {{col.column.displayName}}
          </div>
        </div>
      </div>
      <div class="col-md-9 col-sm-8 col-xs-12 content">
        <div class='row'>
          <div class="col-md-12 col-sm-12 col-xs-12">
            <h3>Field : {{data.displayName}}</h3>
          </div>
        </div>
        <hr class="margin-5-0">

        <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6">
          <div class='row'>
            <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
              <h4 class="no-margin">Header Style</h4>
            </div>
          </div>
          <hr class="buffer-5-0">
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Text Align</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Text Align" [(ngModel)]='data.header.textAlign'>
                <option disabled='disabled' selected> Select Align</option>
                <option value="left">Left</option>
                <option value="center">Center</option>
                <option value="right">Right</option>
              </select>
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Font Size</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <input class="form-control no-radius" placeholder="Font Size" [(ngModel)]='data.header.fontSize' type="number">
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Font Weight</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Font Weight" [(ngModel)]='data.header.fontWeight'>
                <option disabled='disabled' selected> Select Option</option>
                <option value="normal">Normal</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="300">300</option>
                <option value="400">400</option>
                <option value="500">500</option>
                <option value="600">600</option>
                <option value="700">700</option>
                <option value="800">800</option>
                <option value="900">900</option>
                <option value="bold">Bold</option>
                <option value="bolder">Bolder</option>
                <option value="lighter">Lighter</option>
              </select>
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Font Style</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Font Style" [(ngModel)]='data.header.fontStyle'>
                <option disabled='disabled' selected> Select Option</option>
                <option value="normal">Normal</option>
                <option value="italic">Italic</option>
                <option value="oblique">Oblique</option>
              </select>
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Text Orientation</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Text Orientation" [(ngModel)]='data.header.textOrientation'>
                <option disabled='disabled' selected> Select Option</option>
                <option value="unset">Unset</option>
                <option value="mixed">Mixed</option>
                <option value="sideways">Sideways</option>
                <option value="sideways-right">Sideways Right</option>
                <option value="upright">Up Right</option>
              </select>
            </div>
          </div>
          <div class="row padding-10" *ngIf="data.dataType === 'number'">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Thousand separator</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Thousand separator" [(ngModel)]='data.thousandSepartor'>
                <option disabled='disabled' selected> Select Separator</option>
                <option value=" ">(Space)</option>
                <option value=",">,</option>
              </select>
            </div>
          </div>
          <div class="row padding-10" *ngIf="data.dataType === 'number'">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Currency symbol</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <input class="form-control no-radius" placeholder="Currency Symbol" [(ngModel)]='data.currencySymbol'>
            </div>
          </div>
          <div class="row padding-10" *ngIf="data.dataType === 'date'">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Date Format</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="dateFormat" [(ngModel)]='data.dateFormat'>
                <option disabled='disabled' selected> Select Date Format</option>
                <option value='dd/MM/yy'>dd/mm/yy</option>
                <option value='dd/MM/yyyy'>dd/mm/yyyy</option>
                <option value='d/M/yy'>d/m/yy</option>
                <option value='d/M/yyyy'>d/m/yyyy</option>
                <option value='ddMMyy'>ddmmyy</option>
                <option value='ddMMyyyy'>ddmmyyyy</option>
                <option value='ddMMMyy'>ddmmmyy</option>
                <option value='ddMMMyyyy'>ddmmmyyyy</option>
                <option value='dd-MMM-yy'>dd-mmm-yy</option>
                <option value='dd-MMM-yyyy'>dd-mmm-yyyy</option>
                <option value='dMMMyy'>dmmmyy</option>
                <option value='dMMMyyyy'>dmmmyyyy</option>
                <option value='d-MMM-yy'>d-mmm-yy</option>
                <option value='d-MMM-yyyy'>d-mmm-yyyy</option>
                <option value='d-MMMM-yy'>d-mmmm-yy</option>
                <option value='d-MMMM-yyyy'>d-mmmm-yyyy</option>
                <option value='yyMMdd'>yymmdd</option>
                <option value='yyyyMMdd'>yyyymmdd</option>
                <option value='yy/MM/dd'>yy/mm/dd</option>
                <option value='yyyy/MM/dd'>yyyy/mm/dd</option>
                <option value='MMddyy'>mmddyy</option>
                <option value='MMddyyyy'>mmddyyyy</option>
                <option value='MM/dd/yy'>mm/dd/yy</option>
                <option value='MM/dd/yyyy'>mm/dd/yyyy</option>
                <option value='MMM-dd-yy'>mmm-dd-yy</option>
                <option value='MMM-dd-yyyy'>mmm-dd-yyyy</option>
                <option value='yyyy-MM-dd'>yyyy-mm-dd</option>
                <option value='MMM-yy'>mmm-yy</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6">
          <div class='row'>
            <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
              <h4 class="no-margin">Cell Style</h4>
            </div>
          </div>
          <hr class="buffer-5-0">
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Text Align</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Text Align" [(ngModel)]='data.cell.textAlign'>
                <option disabled='disabled' selected> Select Align</option>
                <option value="left">Left</option>
                <option value="center">Center</option>
                <option value="right">Right</option>
              </select>
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Font Size</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <input class="form-control no-radius" placeholder="Font Size" [(ngModel)]='data.cell.fontSize' type="number">
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Font Weight</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Font Weight" [(ngModel)]='data.cell.fontWeight'>
                <option disabled='disabled' selected> Select Option</option>
                <option value="normal">Normal</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="300">300</option>
                <option value="400">400</option>
                <option value="500">500</option>
                <option value="600">600</option>
                <option value="700">700</option>
                <option value="800">800</option>
                <option value="900">900</option>
                <option value="bold">Bold</option>
                <option value="bolder">Bolder</option>
                <option value="lighter">Lighter</option>
              </select>
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Font Style</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Font Style" [(ngModel)]='data.cell.fontStyle'>
                <option disabled='disabled' selected> Select Option</option>
                <option value="normal">Normal</option>
                <option value="italic">Italic</option>
                <option value="oblique">Oblique</option>
              </select>
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Text Orientation</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Text Orientation" [(ngModel)]='data.cell.textOrientation'>
                <option disabled='disabled' selected> Select Option</option>
                <option value="unset">Unset</option>
                <option value="mixed">Mixed</option>
                <option value="sideways">Sideways</option>
                <option value="sideways-right">Sideways Right</option>
                <option value="upright">Up Right</option>
              </select>
            </div>
          </div>
          <div class="row padding-10" *ngIf="data.dataType === 'number'">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Decimal places</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Decimal places" [(ngModel)]='data.decimalPlaces'>
                <option disabled='disabled' selected> Select Decimal Places</option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <hr class="buffer-5-0">
        <div class='row'>
          <div class="col-xs-12 text-lg-right text-md-right text-sm-right">
            <button class='btn btn-sm btn-primary right-buffer-10' (click)='saveFormat()'>Save</button>
            <button class='btn btn-sm btn-default' (click)='cancelFormat()'>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
})
export class MDGFormatComponent {
  selectedColumns: Column[] = [];
  selectedRows: Column[] = [];
  selectedValues: ValueField[] = [];

  selectedColumnsB: Column[] = [];
  selectedRowsB: Column[] = [];
  selectedValuesB: ValueField[] = [];

  @Output() updateFormat: EventEmitter<EventData> = new EventEmitter<EventData>();
  @Output() error: EventEmitter<any> = new EventEmitter<any>();

  data: Column;
  showFormat: boolean = false;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.showFormat) {
      this.showFormat = false;
    }
  }

  constructor(private cdRef: ChangeDetectorRef, private helper: HelperService) {
    this.data = new Column();
    this.data.header = this.helper.getHeaderStyle();
    this.data.cell = this.helper.getCellStyle();
  }

  ShowFormat(cols: Column[], rows: Column[], vals: ValueField[]) {
    this.selectedColumns = cols;
    this.selectedRows = rows;
    this.selectedValues = vals;

    this.selectedColumnsB = this.helper.copyArray(cols);
    this.selectedRowsB = this.helper.copyArray(rows);
    this.selectedValuesB = this.helper.copyArray(vals);

    this.data = new Column();
    this.data.header = this.helper.getHeaderStyle();
    this.data.cell = this.helper.getCellStyle();
    this.showFormat = true;
    this.detectChanges();
  }

  selectColumn(col: Column) {
    this.data = col;
  }

  saveFormat() {
    if (this.data.colName && this.data.colName != null && this.data.colName.trim() != '') {
      this.showFormat = false;
      const obj = new EventData();
      obj.Columns = this.selectedColumns;
      obj.Rows = this.selectedRows;
      obj.Values = this.selectedValues;
      setTimeout(() => {
        this.updateFormat.emit(obj);
      }, 10);
    } else {
      this.error.emit('Please select field to format.');
    }
  }

  cancelFormat() {
    this.showFormat = false;
    this.selectedColumns = this.helper.copyArray(this.selectedColumnsB);
    this.selectedRows = this.helper.copyArray(this.selectedRowsB);
    this.selectedValues = this.helper.copyArray(this.selectedValuesB);
  }

  detectChanges() {
    setTimeout(() => {
      if (
        this.cdRef !== null &&
        this.cdRef !== undefined &&
        !(this.cdRef as ViewRef).destroyed
      ) {
        this.cdRef.detectChanges();
      }
    }, 250);
  }
}
